// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"f03127b8","148":"f2f4bab2","238":"ffc36c32","327":"428cfb4c","456":"70bd2fec","787":"a87d9495","883":"8ba6aebc","889":"792f2bc8","986":"ff236e60"}[chunkId] + ".chunk.js";
};